import AddPlans from "../pages/addPlans";
import Dashboard from "../pages/dashboard";

import { lazyLoad } from "../utils/lazyLoad";

const Home = lazyLoad(() => import("../pages/home/index"));
const Login = lazyLoad(() => import("../pages/login"));
const AllStock = lazyLoad(() => import("../pages/allStock"));
const Subscription = lazyLoad(() => import("../pages/subscription"));
const Faq = lazyLoad(() => import("../pages/FAQ/FaqDetail"));
const Feeds = lazyLoad(() => import("../pages/feeds/index"));
const CoupenPage = lazyLoad(() => import("../pages/Coupen/index"));
const Reports = lazyLoad(() => import("../pages/reports/Reports"));
const routes = [
  {
    path: "/home",
    element: Home,
  },
  {
    path: "/dashboard",
    element: Dashboard,
  },
  {
    path: "/",
    element: Login,
  },
  {
    path: "/stock",
    element: AllStock,
  },
  {
    path: "/subscription",
    element: Subscription,
  },

  {
    path: "/faq",
    element: Faq,
  },
  {
    path: "/addplans",
    element: AddPlans,
  },
  {
    path: "/feeds",
    element: Feeds,
  },
  {
    path: "/coupon",
    element: CoupenPage,
  },
  {
    path: "/reports",
    element: Reports,
  },
];

export default routes;
